// Portalled surfaces mount under document.body, outside the app's
// [data-ui='scarfcn'] wrapper, so they drop out of the font scope. Restamp it.
export const portalScope = { 'data-ui': 'scarfcn' } as const
